import { ACTIONS } from './constants';

export const setSelectedSubsidiaries = (subsidiaries) => {
    return ({
        type: ACTIONS.FILTER_SUBSIDIARIES,
        subsidiaries
    });
};
